import { render } from "./SSLCertificateTab.vue?vue&type=template&id=e51fe02e&scoped=true"
import script from "./SSLCertificateTab.vue?vue&type=script&lang=js"
export * from "./SSLCertificateTab.vue?vue&type=script&lang=js"

import "./SSLCertificateTab.vue?vue&type=style&index=0&id=e51fe02e&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51fe02e"]])

export default __exports__